import { useLiveQuery } from "@tanstack/react-db";

import { fetchFeedPermissionsQuery } from "@/models/repositories";

export type InvalidFeedPermissionsReturn = "Loading" | "NoRightsToViewContentModal" | "Feed";
export const invalidFeedPermissions = ({
  workspaceMembershipId,
  feedId,
  bootstrapComplete,
}: {
  workspaceMembershipId: string | undefined;
  feedId: string;
  bootstrapComplete: boolean;
}): InvalidFeedPermissionsReturn => {
  const { data: feedPermissionsResult, isReady } = useLiveQuery((q) =>
    workspaceMembershipId && feedId ? fetchFeedPermissionsQuery(workspaceMembershipId, feedId)(q) : null,
  );

  // An un-ready query is indistinguishable from an empty one by its data alone; without the ready
  // gate a transiently-empty result would flash the no-rights modal instead of Loading.
  if (!bootstrapComplete || !workspaceMembershipId || !isReady || feedPermissionsResult === undefined) {
    return "Loading";
  }

  const noAccess = feedPermissionsResult.filter((perm) => perm.enabled === false && perm.name === "read").length > 0;
  const filtered = feedPermissionsResult.filter((perm) => perm.enabled);

  if (noAccess || filtered.length === 0) {
    return "NoRightsToViewContentModal";
  }
  return "Feed";
};
